'use client'

import { init } from '@waline/client'
import '@waline/client/dist/waline.css'
import { useEffect } from 'react'

// it localication // should make pr for waline
const locale = {
  nick: 'NickName',
  nickError: 'Il nickname deve essere almeno di 3 lettere',
  mail: 'E-Mail',
  mailError: 'Conferma il tuo indirizzo email',
  link: 'Sito web',
  optional: 'opzionale',
  placeholder: 'Scrivi la tua opinione...',
  sofa: 'Ancora nessun commento',
  submit: 'Invia',
  like: 'Mi piace',
  cancelLike: 'Cancella mi piace',
  reply: 'Rispondi',
  cancelReply: 'Cancella risposta',
  comment: 'Commenti',
  refresh: 'Ricarica',
  more: 'Carica altri...',
  preview: 'Anteprima',
  emoji: 'Emoji',
  uploadImage: 'Carica immagine',
  seconds: 'secondi fa',
  minutes: 'minuti fa',
  hours: 'ore fa',
  days: 'giorni fa',
  now: 'adesso',
  uploading: 'Caricamento',
  login: 'Accesso',
  logout: 'Disconnettiti',
  admin: 'Admin',
  sticky: 'Fissato',
  word: 'parole',
  wordHint: 'Please input comments between $0 and $1 words!\n Current word number: $2',
  anonymous: 'Anonimo',
  level0: 'Mea Mini',
  level1: 'Mea Junior',
  level2: 'Mea User',
  level3: 'Mea Expert',
  level4: 'Mea Master',
  level5: 'Mea God',
  gif: 'GIF',
  gifSearchPlaceholder: 'Cerca GIF',
  profile: 'Profilo',
  approved: 'Approva',
  waiting: 'In attesa',
  spam: 'Spam',
  unsticky: 'Rimuovi dal fissati',
  oldest: 'Più vecchi',
  latest: 'Più recenti',
  hottest: 'Più rilevanti',
  reactionTitle: 'Hai domande? Scrivici!',
}

const WalineComment = () => {
  useEffect(() => {
    init({
      el: '#waline',
      dark: '.dark',
      imageUploader: false,
      search: false,

      meta: ['nick', 'mail'],
      copyright: false,
      serverURL: 'https://waline.meamenu.com',
      reaction: [
        'https://em-content.zobj.net/source/twitter/376/red-heart_2764-fe0f.png',
        'https://em-content.zobj.net/source/twitter/376/fire_1f525.png',
        'https://em-content.zobj.net/source/twitter/376/thumbs-up_1f44d.png',
      ],
      emoji: ['//unpkg.com/@waline/emojis@1.1.0/weibo'],

      requiredMeta: ['nick'],
      // 此处可以配置更多配置，参考Waline官方文档...
      locale,
    })
  }, [])

  return <div id="waline" />
}

export default WalineComment
